import Variants from '../components/product-single/variants';

import {
  createAddItemFormData,
  createDeleteItemFormData,
  listActionStandard,
} from './helper';
import { messageBoxSuccess, messageBoxError } from '../components/message-box';

class PopupEditProduct {
  public openPopup: HTMLElement | null;

  public editProductPopups: NodeListOf<HTMLElement>;

  public editButtons: NodeListOf<HTMLElement>;

  public confirmPopup: HTMLElement;

  public editPopupWasOpen: boolean = false;

  public listId: string;

  public itemId: string;

  public quantity: string;

  public wishlistContent: any;

  public observer: MutationObserver;

  constructor(wishlistContent: any) {
    this.wishlistContent = wishlistContent;
  }

  saveDetails(e: Event) {
    const target = e.currentTarget as HTMLElement;

    this.listId = target.dataset.listId as string;
    this.itemId = target.dataset.elementId as string;
    this.quantity = target.dataset.quantity as string;

    this.editPopupWasOpen = true;

    setTimeout(() => {
      this.openPopup = document.querySelector('.m-popup.m-popup--is-active');
    }, 100);
  }

  async handleActionButton(e: Event) {
    const target = e.currentTarget as HTMLElement;

    switch(target.dataset.action) {
      case 'clone':
        try {
          const newItemFormData = createAddItemFormData(this.itemId, this.listId);
          newItemFormData.append('fields[plaintext_title_1]', this.quantity);

          await listActionStandard(newItemFormData);

          messageBoxSuccess({
            contentDe: `Produkt wurde erfolgreich dupliziert.`,
            contentEn: `Successfully cloned product.`,
          });

          setTimeout(() => {window.location.reload()}, 200);
        } catch (e) {
          console.error(e);

          messageBoxError({
            contentDe: 'Es ist ein Fehler aufgetreten. Produkt konnte nicht dupliziert werden.',
            contentEn: 'An error appeared. Could not clone product.',
          });
        }
        break;
      case 'delete':
        this.openPopup?.classList.remove('m-popup--is-active');
        this.confirmPopup.classList.add('m-popup--is-active');

        const confirmDeleteButton = this.confirmPopup.querySelector('.a-button:last-child') as HTMLLinkElement;

        confirmDeleteButton.addEventListener('click', async (e: Event) => {
          e.preventDefault();

          try {
            await listActionStandard(createDeleteItemFormData(this.itemId, this.listId));

            messageBoxSuccess({
              contentDe: 'Produkt wurde erfolgreich gelöscht.',
              contentEn: 'Successfully deleted product.',
            });

            setTimeout(() => {window.location.reload()}, 200);
          } catch (e) {
            console.error(e);

            messageBoxError({
              contentDe: 'Es ist ein Fehler aufgetreten. Produkt konnte nicht gelöscht werden',
              contentEn: 'An error appeared. Could not delete product.',
            });
          }
        });
        break;
      default:
    }
  }

  async handleMoveProduct(select: HTMLSelectElement) {
    const listToMoveTo = select.selectedOptions[0] as HTMLElement;

    try {
      await listActionStandard(createDeleteItemFormData(this.itemId, this.listId));

      const newItemFormData = createAddItemFormData(this.itemId, listToMoveTo.dataset.listId as string);
      newItemFormData.append('fields[plaintext_title_1]', this.quantity);

      await listActionStandard(newItemFormData);

      messageBoxSuccess({
        contentDe: 'Produkt wurde erfolgreich verschoben.',
        contentEn: 'Successfully moved product.',
      });

      setTimeout(() => {window.location.reload()}, 200);
    } catch (e) {
      console.error(e);

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Produkt konnte nicht verschoben werden.',
        contentEn: 'An error appeared. Could not move product.',
      });
    }
  }

  async handleSubmit(e: Event) {
    e.preventDefault();

    const url = new URL((e.currentTarget as HTMLLinkElement).href);
    const id = url.searchParams.get('elementId') || '';
    const quantity = url.searchParams.get('fields[plaintext_title_1]') || '';

    try {
      const newItemFormData = createAddItemFormData(id, this.listId);
      newItemFormData.append('fields[plaintext_title_1]', quantity);

      await listActionStandard(createDeleteItemFormData(this.itemId, this.listId));
      await listActionStandard(newItemFormData);

      messageBoxSuccess({
        contentDe: 'Produkt wurde erfolgreich gespeichert.',
        contentEn: 'Successfully saved product.',
      });

      setTimeout(() => {window.location.reload()}, 200);
    } catch (e) {
      console.error(e);

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Produkt konnte nicht gespeichert werden.',
        contentEn: 'An error appeared. Could not save product.',
      });
    }
  }

  bindings() {
    this.saveDetails = this.saveDetails.bind(this);
    this.handleActionButton = this.handleActionButton.bind(this);
    this.handleMoveProduct = this.handleMoveProduct.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (!(mutation.target as HTMLElement).classList.contains('m-popup--is-active')) {
            if (!this.confirmPopup.classList.contains('m-popup--is-active')) {
              this.editPopupWasOpen = false;
              this.observer.disconnect();
            }

            const popup = mutation.target as HTMLElement;
            const actionButtons = popup?.querySelectorAll('.a-wishlist-button');
            // const select = popup?.querySelector('.a-wishlist-dropdown select') as HTMLSelectElement;
            // const submitButton = popup?.querySelector('.js-add-to-wishlist');

            actionButtons?.forEach((button) => {
              button.removeEventListener('click', this.handleActionButton);
            });

            // shouldn't matter because these actions trigger reload, but keep it here if bugs appear
            // if (select) {
            //   select.removeEventListener('change', () => {this.handleMoveProduct(select)});
            // }

            // submitButton?.removeEventListener('click', this.handleSubmit);
          }
        }
      }
    });

    if (this.editButtons) {
      this.editButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const popup = document.getElementById(`wishlist-popup-edit-product-${button.dataset.wishlistId}`);
          const variants = new Variants();

          variants.init(null, popup?.dataset.commerceProduct, popup?.id || null, popup);

          this.observer.observe((popup as Node), {attributes: true, attributeFilter: ['class']});

          const actionButtons = popup?.querySelectorAll('.a-wishlist-button');
          const select = popup?.querySelector('.a-wishlist-dropdown select') as HTMLSelectElement;
          // const selectOptions = popup?.querySelectorAll('.a-wishlist-dropdown .select-items div:not(.group)');
          const submitButton = popup?.querySelector('.js-add-to-wishlist');

          actionButtons?.forEach((button) => {
            button.addEventListener('click', this.handleActionButton);
          });

          if (select) {
            select.addEventListener('change', () => {this.handleMoveProduct(select)});
          }

          submitButton?.addEventListener('click', this.handleSubmit);

          this.saveDetails(e);
        });
      });
    }

    if (this.confirmPopup) {
      this.confirmPopup.querySelector('.a-button:first-child')?.addEventListener('click', () => {
        this.confirmPopup.classList.remove('m-popup--is-active');

        if (this.editPopupWasOpen) {
          this.openPopup?.classList.add('m-popup--is-active');
        }
      });
    }
  }

  cache() {
    this.editProductPopups = document.querySelectorAll('.m-wishlist-popup-edit-product');
    this.confirmPopup = document.querySelector('.m-wishlist-popup.m-confirm-popup') as HTMLElement;
    this.editButtons = document.querySelectorAll('.m-wishlist-product-teaser .m-wishlist-product-teaser__edit');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default PopupEditProduct;
